module.exports = __webpack_public_path__ + "img/fig9.17.fe5e9412.png";